import { useNavigate, useParams } from "react-router";
// import { Header } from "../../components/Header/Header";
import { useQuizContent } from "../../providers/QuizContentProvider/useQuizContent";
import { Block } from "../../Components/Block/Block";
import { Container } from "../../components/Container/Container";
import { renderComponent } from "./renderComponent";
import blockStyles from '../../Components/Block/Block.module.scss';
import { OnboardingProgress } from "../../components/OnboardingProgress/OnboardingProgress";
import { useEffect } from "react";
const Quiz = ({theme}) => {
  const { id } = useParams();
  const { data } = useQuizContent();
  const navigate = useNavigate();
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);
  const currentIndex = data.findIndex((item) => item.slug === id);
  useEffect(() => {
    if (currentIndex === -1) {
      navigate('/email/', { replace: true }); // опционально replace: true
    }
  }, [currentIndex, navigate]);

  if (currentIndex === -1) {
    return null;
  }
  const quizItem = data[currentIndex];
  const nextItem = data[currentIndex + 1] || null;
  const nextSlug = nextItem ? nextItem.slug : null;
  const { type } = quizItem;
  return (
    <>
      <OnboardingProgress currentData={quizItem} totalData={data} />
      <Block className={type === 'DailyBenefits' ? blockStyles['white-background'] : undefined}>
        <Container>
          {renderComponent({ quizItem, nextSlug })}
        </Container>
      </Block >
    </>
  );
}
export default Quiz;